module.exports = __webpack_public_path__ + "static/img/banner-1.61c51a96.jpg";